// src/components/PageControls.tsx
import React from 'react';

interface PageControlsProps {
  currentPage: number;
}

export const PageControls: React.FC<PageControlsProps> = ({
  currentPage,
}) => {
  console.log('PageControls rendering with page:', currentPage);
  return (
    <div
      className="page-controls"
      style={{
        position: 'absolute',
        bottom: '16px',
        left: '50%',
        transform: 'translateX(-50%)',
        color: '#000',
        fontSize: '14px',
        zIndex: 10
      }}
    >
       {currentPage}
    </div>
  );
};
